import { atom } from "recoil";

const typeState =atom({
    key: 'type',
    default: 'One Way'
})

export default typeState